import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Script from "next/script";
import { handleEnv } from "@vfit/shared/providers";
var AppDynamics = function(param) {
    var isConfig = param.isConfig;
    var apiKey = handleEnv("NX_APP_DYNAMICS_API_KEY");
    var isDevLocal = function() {
        return "production" === "development";
    };
    if (!apiKey || isDevLocal()) return null;
    if (isConfig) {
        return /*#__PURE__*/ _jsx(Script, {
            id: "appdynamics",
            strategy: "beforeInteractive",
            dangerouslySetInnerHTML: {
                __html: '\n          window["adrum-start-time"] = new Date().getTime();\n           (function(config){\n            config.appKey = "'.concat(apiKey, '";\n            config.adrumExtUrlHttp = \'http://cdn.appdynamics.com\';\n            config.adrumExtUrlHttps = \'https://cdn.appdynamics.com\';\n            config.beaconUrlHttp = \'http://fra-col.eum-appdynamics.com\';\n            config.beaconUrlHttps = \'https://fra-col.eum-appdynamics.com\';\n            config.resTiming = \'{"bufSize":200,"clearResTimingOnBeaconSend":true}\';\n            config.maxUrlLength = 1024;\n            config.longStackTrace = false;\n            config.spa = {"spa2":true};\n          })\n          (window["adrum-config"] || (window["adrum-config"] = {}));\n        ')
            }
        });
    }
    return /*#__PURE__*/ _jsx(Script, {
        id: "appdynamics-adrum",
        strategy: "afterInteractive",
        src: "https://cdn.appdynamics.com/adrum/adrum-latest.js"
    });
};
export default AppDynamics;
